export { default } from './Labeled';
